import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import NgssTagGroup from './NgssTagGroup'
import { formatKeysToCamelCase } from '../util'
import '../assets/css/components/sequence-card.css'

const SequenceCard = ({ sequence }) => {
  return(
    <div className="sequence-card card card-default">
      <div className="card-block">
        <div className='row data-row'>
          <div className="col-md-9 text-col">
            <h3 className='card-title'><span className="semi-bold">{sequence.title}</span></h3>
            <p className='semi-bold'>{sequence.guidingQuestion}</p>
            <div className='scrollable'>
              <div className="demo-card-scrollable">
                <p>{sequence.description}</p>
              </div>
            </div>
            <Link className='btn btn-primary' to={`sequences/${sequence.id}`}>View Storyline</Link>
          </div>
        </div>
        <NgssTagGroup objectWithNgssTags={formatKeysToCamelCase(sequence)} size='small'/>
      </div>
    </div>
  )
}

SequenceCard.propTypes = {
  sequence: PropTypes.object.isRequired
}

export default SequenceCard
